
import * as filterHeaderTypes from '../webcommon/header/filterheader/propTypes';
import { lastWorkingDay } from '../common/helpermethods/HelperMethods';

export const independentAmountColumns = [
    {   
        Header: 'ResultId',
        id : 'id'
    },
    {   
        Header: 'Counterparty',
        id : 'counterparty'
    },
    {   
        Header: 'IA CSA',
        id : 'iaCsa'
    },
    {   
        Header: 'IA Value',
        id : 'iaValue'
    },
    {   
        Header: 'Currency',
        id : 'ccy'
    },
    {
        Header: 'Created At',
        id: 'createdAt'
    },
    {
        Header:'Export',
        id: 'checkbox',
        visible: true
    },
]

export const filterDefinitions = [
    {
        id: 'runDate',
        title: 'Date',
        type: filterHeaderTypes.filterTypes.date,
        defaultValue: { from: lastWorkingDay(), today: false },
        availableValues: undefined,
        availableValuesLocation: undefined,
        server: true,
        useValidation: true,
        hideAllButton: true,
        hideToday: true,
        singleDay: true,
        fromOnly: true,
    }
]
export const defaultFilters = [
    {
        value: {
            from: lastWorkingDay(),
            to: lastWorkingDay(),
            today: false
        },
        definition: filterDefinitions.find(def => def.id === 'runDate')
    }
]